import { RegisterOptions, useController, useFormContext } from "react-hook-form";
import React from "react";
import { makeStyles } from "@material-ui/core";
import TextInput from "./TextInput";
import Button from "../Button/Button";

interface FormTextInputWithButtonProps {
  name: string;
  placeholder?: string;
  label?: string;
  description?: string;
  type?: string;
  rules?: RegisterOptions;
  leftIcon?: React.ReactNode;
  buttonLabel: string;
  buttonVariant?: "success" | "neutral" | "error" | "outline" | "outline-error" | "gray";
  buttonSize?: "small" | "medium" | "large";
  onButtonClick?: (value: string) => void;
  disabled?: boolean;
  inputStyle?: React.CSSProperties;
  className?: string;
  buttonClassName?: string;
  showRightButton?: boolean;
}

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "100%",
  },
}));

const FormTextInputWithButton = ({
  name,
  placeholder,
  label,
  description,
  type,
  rules,
  leftIcon,
  buttonLabel,
  buttonVariant = "neutral",
  buttonSize = "large",
  onButtonClick,
  disabled,
  inputStyle,
  className,
  buttonClassName,
  showRightButton = true,
}: FormTextInputWithButtonProps) => {
  const { control } = useFormContext();
  const classes = useStyles();
  const { field, fieldState } = useController({ name, control, rules });

  const handleButtonClick = () => {
    onButtonClick?.((field.value || "").toString());
  };

  return (
    <div className={[classes.container, className].filter(Boolean).join(" ")}>
      <TextInput
        value={(field.value || "").toString()}
        onChange={field.onChange}
        placeholder={placeholder || ""}
        label={label}
        description={description}
        type={type}
        error={fieldState.error?.message}
        leftIcon={leftIcon}
        disabled={disabled}
        inputStyle={{
          minHeight: 44,
          height: 40,
          fontSize: 24,
          ...inputStyle,
        }}
        className={className}
        rightIcon={
          showRightButton ? (
            <Button
              variant={buttonVariant}
              size={buttonSize}
              className={buttonClassName}
              onClick={handleButtonClick}
              disabled={disabled}
            >
              {buttonLabel}
            </Button>
          ) : null
        }
      />
    </div>
  );
};

export default FormTextInputWithButton;
